export const VENUE_UUID = "5c3f403f-497a-48c3-ae56-21005e2b841f"